// extracted by mini-css-extract-plugin
export default {"img":"SponsorsSection_img__EDLCW","qualcommimg":"SponsorsSection_qualcommimg__z3RDD"};